import * as types from "./actionTypes";

// Consolidated Attendance Report
export const fetchAttendanceConsolidatedReport = (payload) => ({
  type: types.FETCH_ATTENDANCE_CONSOLIDATED_REPORT_REQUEST,
  payload,
});

// Day Wise Attendance Report
export const fetchDayWiseAttendanceReport = (payload) => ({
  type: types.FETCH_DAY_WISE_ATTENDANCE_REPORT_REQUEST,
  payload,
});

// Late Attendance Report
export const fetchLateAttendanceReport = (payload) => ({
  type: types.FETCH_LATE_ATTENDANCE_REPORT_REQUEST,
  payload,
});

export const fetchAbsenteeismReport = (payload) => ({
  type: types.FETCH_ABSENTEEISM_REPORT_REQUEST,
  payload,
});

export const fetchExtraHoursReport = (payload) => ({
  type: types.FETCH_EXTRA_HOURS_REPORT_REQUEST,
  payload,
});

export const getMobilePunchReport = (formData) => ({
  type: types.GET_MOBILE_PUNCH_REPORT_REQUEST,
  payload: formData,
});

export const fetchLeaveReportRequest = (payload) => ({
  type: types.FETCH_LEAVE_REPORT_REQUEST,
  payload,
});

export const fetchShiftReportRequest = (payload) => ({
  type: types.FETCH_SHIFT_REPORT_REQUEST,
  payload,
});

export const fetchShiftDetailsReportRequest = (payload) => ({
  type: types.FETCH_SHIFT_DETAILS_REPORT_REQUEST,
  payload,
});

export const fetchShiftLogReportRequest = (payload) => ({
  type: types.FETCH_SHIFT_LOG_REPORT_REQUEST,
  payload,
});

export const fetchLeaveBalanceReportRequest = (payload) => ({
  type: types.FETCH_LEAVE_BALANCE_REPORT_REQUEST,
  payload,
});

export const fetchForm6ReportRequest = (payload) => ({
  type: types.FETCH_FORM6_REPORT_REQUEST,
  payload,
});

export const fetchForm34ReportRequest = (payload) => ({
  type: types.FETCH_FORM34_REPORT_REQUEST,
  payload,
});

export const fetchBreakInReportRequest = (payload) => ({
  type: types.FETCH_BREAKIN_REPORT_REQUEST,
  payload,
});


export const resetAttendanceReport = () => ({
  type: types.RESET_ATTENDANCE_REPORT,
});